<template>
  <div>
    <!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'信息漏斗'},{title:'目标对阵用户'}]" />-->
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <!-- 结果展示 -->
                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                  <h1>修改或新增top用户列表</h1>
                </div>
                <div class="h-pieceCon2" style="padding:0">
                <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                  <el-table
                      ref="multipleTable"
                      @selection-change="handleSelectionChange"
                      :data="tableData"
                      :border="true"
                      stripe
                      max-height="560"
                      style="width: 100%">
                      <el-table-column
              label="序号"
              type="index"
              fixed
              width="50">
          </el-table-column>
            <el-table-column prop="year" label="类型" width="100px">
              <template slot-scope="scope">
                <span v-if="scope.row.xiugaitype == 1">修改后数据</span>
                <span v-if="scope.row.xiugaitype == 2">修改前数据</span>
              </template>
            </el-table-column>
            <el-table-column prop="year" label="年度" width="60px"></el-table-column>
            <el-table-column prop="userUnitName" label="用户单位" width="140px" >
              <template slot-scope="scope">
                <div :class="[tableData[0].userUnitName!=scope.row.userUnitName? baseClass:'']">
                  {{scope.row.userUnitName}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="province" label="省份" width="90px">
              <template slot-scope="scope">
                <div :class="[tableData[0].province!=scope.row.province? baseClass:'']">
                  {{scope.row.province}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="scenesName" label="渠道" width="90px">
              <template slot-scope="scope">
                <div :class="[tableData[0].scenesName!=scope.row.scenesName? baseClass:'']">
                  {{scope.row.scenesName}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="schoolTypeName" label="用户分类" width="90px">
              <template slot-scope="scope">
                <div :class="[tableData[0].schoolTypeName!=scope.row.schoolTypeName? baseClass:'']">
                  {{scope.row.schoolTypeName}}
                </div>
              </template>
            </el-table-column>
<!--            <el-table-column prop="isNew" label="是否新建" width="90px"></el-table-column>-->
            <el-table-column prop="isNew" label="是否新建">
              <template slot-scope="scope">
                <div :class="[tableData[0].isNew!=scope.row.isNew? baseClass:'']">
                  <span v-if="scope.row.isNew == 0">否</span> <span v-if="scope.row.isNew == 1">是</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="isZhidan" label="是否直单">
              <template slot-scope="scope">
                <div :class="[tableData[0].isZhidan!=scope.row.isZhidan? baseClass:'']">
                <span v-if="scope.row.isZhidan == 0">否</span> <span v-if="scope.row.isZhidan == 1">是</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="q1Target" :label="'Q1目标\n(万元)'" width="90px">
              <template slot-scope="scope">
                <div :class="[tableData[0].q1Target!=scope.row.q1Target? baseClass:'']">
                  {{scope.row.q1Target}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="q2Target" :label="'Q2目标\n(万元)'" width="90px">
              <template slot-scope="scope">
                <div :class="[tableData[0].q2Target!=scope.row.q2Target? baseClass:'']">
                  {{scope.row.q2Target}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="q3Target" :label="'Q3目标\n(万元)'" width="90px">
              <template slot-scope="scope">
                <div :class="[tableData[0].q3Target!=scope.row.q3Target? baseClass:'']">
                  {{scope.row.q3Target}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="q4Target" :label="'Q4目标\n(万元)'" width="90px">
              <template slot-scope="scope">
                <div :class="[tableData[0].q4Target!=scope.row.q4Target? baseClass:'']">
                  {{scope.row.q4Target}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="cuname" label="创建人" width="100px" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="cdate" label="创建时间" width="140px" ></el-table-column>
                  </el-table>
                </div>
                <div class="bannerBox2">
                  <div class="h-row h-mrt1">
                    <div class="h-rowIn">
                      <div class="h-rowBox">
                        <div class="h-rowCon">
                          <div class="h-pieceIn2">
                            <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                            <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                              <h1>TOP用户审核信息</h1>
                            </div>
                            <div class="h-pieceCon2 ">
                              <div class="h-formLine weekplandetail11" style="position: relative;">
                                <el-form :inline="true" :model="delData">
                                  <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                style="width: 100%!important;">
                                    <el-input
                                        v-model="delData.auditMind2"
                                        placeholder="请输入"></el-input>
                                  </el-form-item>
                                </el-form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div style="text-align: center;margin-top: 0.3rem">
                  <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack"> 返回 </el-button>

                  <el-button class="h-btn h-bBtn h-bgred" @click="pass(2)" v-if="!daquflag">驳回</el-button>
                  <el-button class="h-btn h-bBtn h-bggreen" @click="pass(1)" v-if="!daquflag">通过</el-button>

                  <el-button class="h-btn h-bBtn h-bgred" @click="daquPass(2)" v-if="daquflag">大区驳回</el-button>
                  <el-button class="h-btn h-bBtn h-bggreen" @click="daquPass(1)" v-if="daquflag">大区通过</el-button>

                  <el-button class="h-btn h-bBtn" @click="viewpress">
                    审批跟踪
                  </el-button>
                  <div class="h-pagination2">
                    <pagination :page="querypage" @query="getListByInstid"/>
                  </div>
                </div>
                <viewhistory :visible.sync="showhistory" v-if="showhistory"
                             :id="instid"/>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import agentCopyService from "../../../api/loud/agent/agentCopyService";

export default {
  data() {
    return {
      baseClass: 'active', // 基础类名
      q: {
        customerName: '',
        agentName: '',
        scenesName: '',
        areaName: '',
        pageNo: 1,
        pageSize: 10,
        total: 0,
        year: '',
      },
      querypage : {
        instid: this.$route.query.instid,
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },


      delData: [],
      qyearList: [],
      quyuList: [],
      qudaoList: [],
      size: '',
      tableData: [],
      refid:null,
      //表格
      multipleSelection: [],
      // 展开折叠筛选
      isScreen: false,
      uploaddownexcelflag: false,
      daquflag:false,
      newDialog: false,
      editDialog: false,
      yearList: [new Date().getFullYear(), new Date().getFullYear() + 1],
      weekList: [],
      authTypeListEdit: [],
      disEdit: false,
      workList: [],
      AuthoCheck: '',
      authTypeList: [],
      userList: [0],
      weekPlanList: [],
      groupList: [],
      groupArr: [],
      titleDig: "",
      iscontract : '',//是否维护了合同

      shenglist: [],// 省份list
      cityList: [],      //城市list
      customerNameList: [], //用户单位list
      agentList: [],      //签约经销商
      showhistory:false,
      instid:"",
    }

  },

  methods: {

    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // selectPageAll() {
    //   console.log("12312312312", this.q)
    //   ss.grabOrderApi.selectPageTargetAgainstUser(this.q).then(res => {
    //     console.log(res)
    //     console.log("total", res.total)
    //     this.tableData = res.records
    //     this.q.total = res.total
    //     console.log("table", this.tableData)
    //   })
    // },
    //
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    uploadExcelFilecallback(rd) {
      this.$msg.msgs(rd.msg);
      this.selectPageAll()
    },
    changeTop(val){
      console.log("changeTop",val);
    },
    pass(aaa){
      console.log(aaa,"20231208");
      let query = {
        taskid:this.$route.query.taskid,
        aaa:aaa,
        auditMind2:this.delData.auditMind2,
        usercode: this.delData.usercode,
        instid:this.$route.query.instid,
        ywid:this.$route.query.ywid,
        list:this.tableData,
        isUpdateOrDelType:"update",
      }
      console.log(aaa,"2023120811111111111");
      ss.grabOrderApi.updateAnddelTopProcess(query).then(res => {
        this.$msg.alerts("提交成功！", () => {
          //刷新右上角的代办个数
          this.$store.dispatch("searchTasktotal")
          //跳转回系统的代办列表
          this.$router.push({
            path: '/personal/dealCenter'
          })
        })
      })
    },

    viewpress() {
      this.showhistory = true;
    },
    goBack() {
      this.$router.push({
        path: '/agent/agentCopy'
      })
    },
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    exit() {
      this.closeDialog()
    },

    getListByInstid() {
      this.querypage.instid = this.$route.query.instid;
      ss.grabOrderApi.selectPageTopManagementUser(this.querypage).then(rd => {
        console.log(rd);
        this.querypage.total = rd.total;
        this.tableData = rd.records;
      })
    },
  },

  created() {
      this.getListByInstid();
      this.instid = this.$route.query.instid;
  },
  components: {
    uploaddownexcel,
  },
}
</script>
<style scoped>
/deep/ .h-formbLine .el-form-item__label {
  width: 100px;
}


/deep/ .h-formbLine .el-form-item__content {
  width: 150px;
}
.active{
  color:red;
}
</style>
